import React from "react";
import TextField from "@material-ui/core/TextField";
import Modal from "components/Tvendo/Common/ModalBase";

export default function ModalManufacturer(props) {
  const manufacturer = props.model;

  return (
    <Modal
      title="Manufactura"
      model={manufacturer}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="logi/manufacturer"
      state
    >
      <TextField
        label="Código"
        type="text"
        name="FirmCode"
        margin="normal"
        fullWidth
        defaultValue={!!manufacturer ? manufacturer.FirmCode : ""}
        required
      />
      <TextField
        label="Descripción"
        type="text"
        name="FirmName"
        margin="normal"
        fullWidth
        defaultValue={!!manufacturer ? manufacturer.FirmName : ""}
        required
      />
    </Modal>
  );
}
